module.exports = __webpack_public_path__ + "static/img/sign-in.98b0bd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/sign-in.png
// module id = 1mSS
// module chunks = 1